import { render, staticRenderFns } from "./_FormCriarResposta.vue?vue&type=template&id=fae411d6"
import script from "./_FormCriarResposta.vue?vue&type=script&lang=ts"
export * from "./_FormCriarResposta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports